import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'First Name is required.' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Last Name is required.' }
      ]
    },
    addressLine1: {
      validations: []
    },
    city: {
      validations: []
    },
    state: {
      validations: []
    },
    postal: {
      validations: []
    },
    email: {
      validations: [
        { type: 'required', message: 'Email Address is required.' },
        {
          type: 'regex',
          pattern:
            "[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?",
          message: 'Please provide a valid email.'
        }
      ]
    },
    telNumber: {
      validations: [
        { type: 'required', message: 'Phone is required.' },
        {
          type: 'regex',
          pattern:
            '[(]{0,1}[0-9]{3}[) ]{0,2}[-s.]{0,1}[0-9]{3}[-s.]{0,1}[0-9]{4}',
          message: 'Please provide a valid phone number.'
        }
      ]
    },
    theme: {
      validations: [
        { type: 'required', message: 'Type of Event is required.' }
      ]
    },
    eventDate: {
      validations: [
        { type: 'required', message: 'Requested Event Date is required.' },
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    siteaddress: {
      validations: [
        { type: 'required', message: 'Event Location Address is required.' },
      ]
    },
    sitecity: {
      validations: [
        { type: 'required', message: 'Event Location City is required.' },
      ]
    },
    sitestate: {
      validations: [
        { type: 'required', message: 'Event Location State is required.' },
      ]
    },
    sitepostal: {
      validations: [
        { type: 'required', message: 'Event Location Zip/Postal Code is required.' },
      ]
    },
    allergyinfo: {
      validations: [
        { type: 'required', message: 'Dietary Restrictions is required.' },
      ]
    },
    partyname: {
      validations: []
    },
    plannedguestcount: {
      validations: [
        { type: 'required', message: 'Number in Group is required.' }
      ]
    },
    comments: {
      validations: []
    },
    reference: {
      validations: []
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Name *',
            mapping: 'headerLabel',
            customClasses: ['heading']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name*',
            mapping: 'firstName',
            customClasses: ['no-label']
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name*',
            mapping: 'lastName',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'First Name',
            mapping: 'headerLabel',
            customClasses: ['subheading']
          },
          {
            type: 'label',
            size: 'Medium',
            label: 'Last Name',
            mapping: 'headerLabel',
            customClasses: ['subheading']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Address',
            mapping: 'headerLabel',
            customClasses: ['heading']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Address',
            mapping: 'addressLine1',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Address 1',
            mapping: 'headerLabel',
            customClasses: ['subheading']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'City',
            mapping: 'city',
            customClasses: ['no-label']
          },
          {
            type: 'text',
            size: 'Small',
            label: 'State',
            mapping: 'state',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'City',
            mapping: 'headerLabel',
            customClasses: ['subheading']
          },
          {
            type: 'label',
            size: 'Small',
            label: 'State/Province',
            mapping: 'headerLabel',
            customClasses: ['subheading']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Zip/Postal Code',
            mapping: 'postal',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Zip/Postal Code',
            mapping: 'headerLabel',
            customClasses: ['subheading']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email Address *',
            mapping: 'email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number *',
            mapping: 'telNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Type of Event *',
            mapping: 'headerLabel',
            customClasses: ['heading']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Birthday party, family reunion, company banquet, etc.',
            mapping: 'headerLabel',
            customClasses:['caption']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Type of Event *',
            mapping: 'theme',
            customClasses:['no-label']
          }
        ]
      },  
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Requested Event Date *',
            mapping: 'eventDate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Event Location *',
            mapping: 'headerLabel',
            customClasses: ['heading']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Address',
            mapping: 'siteaddress',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Address 1',
            mapping: 'headerLabel',
            customClasses: ['subheading']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'City',
            mapping: 'sitecity',
            customClasses: ['no-label']
          },
          {
            type: 'text',
            size: 'Small',
            label: 'State',
            mapping: 'sitestate',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'City',
            mapping: 'headerLabel',
            customClasses: ['subheading']
          },
          {
            type: 'label',
            size: 'Small',
            label: 'State/Province',
            mapping: 'headerLabel',
            customClasses: ['subheading']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Zip/Postal Code',
            mapping: 'sitepostal',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Zip/Postal Code',
            mapping: 'headerLabel',
            customClasses: ['subheading']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Dietary Restrictions *',
            mapping: 'headerLabel',
            customClasses: ['heading']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Gluten intolerance, lactose intolerant, peanut allergies, etc.',
            mapping: 'headerLabel',
            customClasses:['caption']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Dietary Restrictions *',
            mapping: 'allergyinfo',
            customClasses:['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Group Name',
            mapping: 'partyname'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Number in Group *',
            mapping: 'plannedguestcount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Rentals Needed',
            mapping: 'headerLabel',
            customClasses: ['heading']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Tables, silverware, seating, decor, etc.',
            mapping: 'headerLabel',
            customClasses:['caption']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Rentals Needed',
            mapping: 'comments',
            customClasses:['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Referred by',
            mapping: 'reference'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'XLarge',
            label: 'Comments / Additional Notes',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SUBMIT'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Wild & Woodsy Catering Contact Form',
    formId: '491',
    clientKey: 'C415C86B-C2A3-4644-8CA5-95C6A34B8B5F',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText:
      'Thank you! Your web inquiry has been successfully sent. We will contact you very soon!',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/wildwoodsycatering/form_structure.js